import { TNavLinkProps } from '@/shared/ui/NavLink';

import { StyledNavigationLink } from './styles/navigationLink';

export const NavigationLink = ({
  children,
  to,
  target,
  rel,
  onClick,
  ...rest
}: TNavLinkProps) => {
  return (
    <StyledNavigationLink
      to={to}
      target={target}
      rel={rel}
      onClick={onClick}
      {...rest}
    >
      {children}
    </StyledNavigationLink>
  );
};
